import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { faInfoCircle, faPencil, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { CustomSatisfactionInterface } from 'src/app/util/interfaces/customSatisfaction';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { CustomSatisfactionRequestService } from './service/custom-satisfaction-request.service';
import { catchError } from 'rxjs';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';

@Component({
	selector: 'register-form-custom-satisfaction-request',
	templateUrl: './custom-satisfaction-request.component.html',
	styleUrl: './custom-satisfaction-request.component.scss',
})
export class CustomSatisfactionRequestComponent implements OnInit {
	icons = {
		faPencil: faPencil,
		faTrash: faTrash,
		faInfoCircle: faInfoCircle,
		faPlus: faPlus,
	};

	labels: any = {
		lbl_geral_salvar: 'Save',
		lbl_successful_updated: 'Successful updated',
		lbl_preencha_todos_asteriscos: 'Fill in at least the fields marked by *',
		lbl_bulletin_actions: 'actions',
		lbl_geral_atualizar: 'Update',
		lbl_geral_deletado_com_sucesso: 'Successfully deleted',
		lbl_geral_criado_com_sucesso: 'Successfully created',
		lbl_geral_resposta: 'Response',
		lbl_erro_ao_salvar: 'There was an error saving, try again',
		lbl_geral_pergunta: 'Question',
		lbl_geral_responses: 'Responses',
		lbl_comentario: 'Comment',
		lbl_pesquisa_de_satisfacao_de_chamados_personalizada: 'Custom Request Satisfaction Survey',
		lbl_clicar_para_expandir_mais_um_campo_de_resposta: 'Click to expand one more response field',
		lbl_geral_excluir: 'Delete',
		lbl_geral_editar: 'Edit',
		lbl_geral_voltar: 'Back',
		lbl_geral_novo: 'New',
	};

	isLoadingLabels = true;
	isLoadingSatisfaction = true;
	isUpdating = false;
	isManagement = true;

	showForm = false;
	showEditForm = false;

	showOption3 = false;
	showOption4 = false;
	showOption5 = false;
	showAddIcon = true;

	searchText = '';

	filteredItems: CustomSatisfactionInterface[] = [];
	customSatisfactionList: CustomSatisfactionInterface[] = [];

	customSatisfaction = {} as CustomSatisfactionInterface;
	form: CustomSatisfactionInterface = {
		id: undefined,
		customer: '',
		question: '',
		comment: false,
		question_options: {
			option1: '',
			option2: '',
			option3: '',
			option4: '',
			option5: '',
		},
	};

	formUpdate: CustomSatisfactionInterface = {
		id: '',
		customer: '',
		question: '',
		comment: false,
		question_options: {
			option1: '',
			option2: '',
			option3: '',
			option4: '',
			option5: '',
		},
	};

	selectedTab = 'management';

	searchHeader: mspTableHeaderI[] = [
		{ name: 'question', value: 'lbl_geral_pergunta', colType: 'text' },
		{ name: 'formattedOptions', value: 'lbl_geral_responses', colType: 'text' },
		{ name: 'comment', value: 'lbl_comentario', colType: 'boolean' },
		{ name: 'icon', value: 'lbl_bulletin_actions', colType: 'icon' },
	];

	constructor(
		private customSatisfactionRequestService: CustomSatisfactionRequestService,
		private notificationService: NotificationService,
		private labelsService: LabelsService,
		private cdr: ChangeDetectorRef
	) {}

	ngOnInit() {
		this.labelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.getAllCustomSatisfaction();
		this.filteredItems = this.customSatisfactionList;
	}

	getAllCustomSatisfaction(): void {
		this.customSatisfactionRequestService.getAllCustomSatisfaction().subscribe((data: CustomSatisfactionInterface[]) => {
			this.customSatisfactionList = data;
			this.isLoadingSatisfaction = false;
			this.cdr.detectChanges();
		});
	}

	createCustomSatisfaction(form: CustomSatisfactionInterface): void {
		if (this.isUpdating) return;

		if (
			form.question === '' ||
			((form.question_options.option1 === '' || form.question_options.option2 === '') &&
				(form.comment === 0 || form.comment === false))
		) {
			this.notificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			return;
		}

		this.isUpdating = true;
		this.customSatisfactionRequestService
			.postCustomSatisfaction(form)
			.pipe(
				catchError((error) => {
					this.notificationService.setNotificationMessage(this.labels.lbl_erro_ao_salvar);
					this.resetForm();
					this.showForm = false;
					this.isUpdating = false;
					this.isManagement = true;
					throw error;
				})
			)
			.subscribe(() => {
				this.getAllCustomSatisfaction();
				this.notificationService.setNotificationMessage(this.labels.lbl_geral_criado_com_sucesso);
				this.resetForm();
				this.showForm = false;
				this.isUpdating = false;
				this.isManagement = true;
			});
	}

	resetForm(): void {
		this.form = {
			id: '',
			customer: '',
			question: '',
			comment: false,
			question_options: {
				option1: '',
				option2: '',
				option3: '',
				option4: '',
				option5: '',
			},
		};
	}

	updateCustomSatisfaction(item: CustomSatisfactionInterface): void {
		if (this.isUpdating) return;

		if (
			item.question !== '' &&
			((item.question_options.option1 !== '' && item.question_options.option2 !== '' && item.comment === 0) || item.comment === 1)
		) {
			this.isUpdating = true;
			this.customSatisfactionRequestService.updateCustomSatisfaction(item).subscribe(() => {
				this.notificationService.setNotificationMessage(this.labels.lbl_successful_updated);

				const index = this.customSatisfactionList.findIndex((index_) => index_.id === item.id);
				if (index !== -1) {
					this.customSatisfactionList[index] = item;
				}

				// Notifique o Angular para atualizar a exibição
				this.cdr.detectChanges();
				this.showEditForm = false;
				this.isUpdating = false;
				this.isManagement = true;
			});
		} else {
			this.notificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
		}
	}

	backManagement(): void {
		this.isManagement = true;
		this.showEditForm = false;
		this.showForm = false;
		this.isUpdating = false;
	}

	deleteCustomSatisfaction(id: any): void {
		if (this.isUpdating) return;

		this.isUpdating = true;
		this.showEditForm = true;
		this.customSatisfactionRequestService.deleteCustomSatisfaction(id).subscribe(() => {
			this.getAllCustomSatisfaction();
			this.notificationService.setNotificationMessage(this.labels.lbl_geral_deletado_com_sucesso);
			this.isUpdating = false;
			this.showEditForm = false;
			this.isManagement = true;
		});
	}

	openUpdatedForm(item: CustomSatisfactionInterface): void {
		this.formUpdate = { ...item };
		this.selectedTab = 'edit';
		this.isManagement = false;
		this.showEditForm = !this.showEditForm;
	}

	openForm(item: CustomSatisfactionInterface): void {
		this.form = { ...item };
		this.selectedTab = 'create';
		this.isManagement = false;
		this.showForm = !this.showForm;
	}

	searchItems(): void {
		this.filteredItems = this.customSatisfactionList.filter((item) => {
			const questionOptionsValues = Object.values(item.question_options || {}).map((option) => option.toLowerCase());
			return (
				item.question.toLowerCase().includes(this.searchText.toLowerCase()) ||
				questionOptionsValues.some((option) => option.includes(this.searchText.toLowerCase())) ||
				(item.comment === true && this.labels.lbl_geral_ativo.toLowerCase().includes(this.searchText.toLowerCase())) ||
				(item.comment === false && this.labels.lbl_geral_desativado.toLowerCase().includes(this.searchText.toLowerCase()))
			);
		});
	}

	confirmButton(elementReference: HTMLElement): void {
		this.notificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirm');
		setTimeout(() => {
			elementReference.classList.remove('confirm');
		}, 5000);
	}

	toggleNextOptionForm(): void {
		if (!this.showOption3) {
			this.showOption3 = true;
		} else if (!this.showOption4) {
			this.showOption4 = true;
		} else if (!this.showOption5) {
			this.showOption5 = true;
			this.showAddIcon = false; // Esconde o ícone de adicionar quando todas as opções foram mostradas
		}
	}
}
